// Non-component helpers for the seller catalog product card. Split out so
// SellerCatalogProductCard.tsx only exports components
// (react-refresh/only-export-components).

export function formatCatalogCategory(category: string) {
  const normalized = category
    .replaceAll('_', ' ')
    .replaceAll('-', ' ')
    .trim()
    .toLowerCase()
  return normalized ? normalized[0].toUpperCase() + normalized.slice(1) : ''
}
